module.exports = "/static/assets/800f6f1573677d59954e8d3164602287.svg";